export const COLUMNS = [
    // {
    //     Header: 'Türü',
    //     accessor: 'formType',
    // },
    {
        Header: 'Tarih',
        accessor: 'date', // accessor is the "key" in the data
    },
    {
        Header: 'Takip No',
        accessor: 'workOrderId',
    },
    {
        Header: 'Onaylayan',
        accessor: 'name',
    },
    // {
    //     Header: 'Kontrol Eden',
    //     accessor: 'userApprover',
    // },
    {
        Header: 'İşlemler',
        accessor: 'icons',
    },
]